import { CardType, FORMAT } from 'types/deck'

import styles from './canlanderPointsTag.module.scss'
import { useAppSelector } from 'app-redux/hooks'

type Props = {
  card: CardType
}

const CompanionTag = ({ card }: Props) => {
  const deckFormat = useAppSelector(state => state.deck.format)

  if (deckFormat !== FORMAT.CANLANDER) return null
  if (!card.canlanderPoints) return null

  return (
    <div className={styles.tag}>
      <span>{card.canlanderPoints}</span>
    </div>
  )
}

export default CompanionTag
